import { PointsForStatementCreditApi } from '@/src/experiences/points-to-statement-credit/stores'
import { ID } from '@acre-rewards/lib'
import { MesaCardSkeleton } from './MesaCardSkeleton'
import { CurrentBalanceCard } from './CurrentBalanceCard'
import * as CardAccounts from '@/src/experiences/card-accounts'
import { DesignSystem } from '@/src/design-system'

function CurrentBalanceForCardAccount({ cardAccountId }: { cardAccountId: ID.CardAccount }) {
  const { data, refetch: refetchCardAccountSummary } = PointsForStatementCreditApi.endpoints[
    'GET /card/accounts/:cardAccountId'
  ].useQuery({ params: { cardAccountId } })

  DesignSystem.ScreenWideReload.useReloadListener(async () => {
    await refetchCardAccountSummary()
  })

  if (!data) {
    return <MesaCardSkeleton />
  }

  const { summary } = data

  return (
    <CurrentBalanceCard
      cardName="Mesa Homeowners Card"
      currentBalanceInCents={summary.currentBalance.totalCents}
    />
  )
}

export function CurrentBalancePlatform() {
  const firstCardAccount = CardAccounts.Hooks.useGetFirstAccount()

  if (!firstCardAccount.data) {
    return <MesaCardSkeleton />
  }

  if (!firstCardAccount.data.id) {
    return null
  }

  return <CurrentBalanceForCardAccount cardAccountId={firstCardAccount.data.id} />
}
